import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function Footer() {
  const { t } = useTranslation('footer')
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white/80 backdrop-blur-xl border-t border-gray-200/50 relative z-0">
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Main footer content - 3 columns with clear hierarchy */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-4">
          {/* Column 1: Product */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wide">
              {t('product.title')}
            </h3>
            <ul className="space-y-1.5">
              <li>
                <Link
                  to="https://rtsinv.com/synstream/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('product.about')}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/features"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('product.features')}
                </Link>
              </li>
              <li>
                <Link
                  to="/changelog"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('product.changelog')}
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Column 2: Resources */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wide">
              {t('resources.title')}
            </h3>
            <ul className="space-y-1.5">
              <li>
                <a
                  href="https://docs.google.com/document/d/1GY3_gTNkjoPS3XBrCWl10c4uATxiOupCvAeMSVVsfJY/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('resources.documentation')}
                </a>
              </li>
              <li>
                <a
                  href="https://rtsinv.com/contact-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('resources.support')}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wide">
              {t('legal.title')}
            </h3>
            <ul className="space-y-1.5">
              <li>
                <Link
                  to="/terms"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('legal.terms')}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('legal.privacy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-xs text-gray-500 hover:text-primary transition-colors"
                >
                  {t('legal.cookies')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar - Copyright */}
        <div className="pt-4 border-t border-gray-200/50">
          <p className="text-xs text-gray-500 text-center">
            © {currentYear} {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  )
}
